"use client";

import { TCtaSection } from "@shared/types";
import { ButtonLink } from "@shared/ui";
import Image from "next/image";

export function CareerCtaSection({ title, description, illustration, background, button }: TCtaSection) {
  return (
    <div
      className="relative text-white py-20 sm:py-[100px] lg:py-20"
      style={{
        background: "linear-gradient(264.23deg, #134E67 4.59%, #1DB0DE 80.88%)",
      }}
    >
      {background && (
        <Image
          src={background?.data?.attributes?.url || ""}
          alt={background?.data?.attributes?.alternativeText || background?.data?.attributes?.name || "CTA Background"}
          width={background?.data?.attributes?.width || 1000}
          height={background?.data?.attributes?.height || 1000}
          className="h-full w-full object-cover bottom-0 left-0 absolute z-1 object-center lg:object-left-bottom"
        />
      )}
      <div className="container relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-[60px] sm:gap-20 items-stretch">
          {illustration && illustration.data && (
            <div className="order-2 lg:order-1 col-span-6 h-full flex flex-col justify-end">
              <Image
                src={illustration.data?.attributes?.url || ""}
                width={illustration.data?.attributes?.width || 780}
                height={illustration.data?.attributes?.height || 788}
                alt={illustration.data?.attributes?.alternativeText || illustration.data?.attributes?.name}
                className="w-full h-auto px-4 lg:mx-0"
              />
            </div>
          )}
          {/* py-14 lg:py-20 xl:py-40 */}

          <div className="order-1 lg:order-2 col-span-6 h-full flex flex-col justify-center ">
            <h3 className="text-5xl sm:text-6xl font-bold leading-[115%]">{title || "CTA"}</h3>
            {description && <p className="mt-8 text-xl leading-[140%]">{description}</p>}
            {button && (
              <div className="mt-10">
                <ButtonLink {...button} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
